<glxy-page [isLoading]="isLoading()">
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button (click)="back()"></glxy-page-nav-button>
    </glxy-page-nav>

    <glxy-page-title>{{ 'INBOX.SETTINGS.WEBCHAT_CONFIGURATION' | translate }}</glxy-page-title>
  </glxy-page-toolbar>

  <glxy-page-wrapper widthPreset="narrow" *ngIf="!!error()">
    <ng-container
      [ngTemplateOutlet]="errorTemplate"
      [ngTemplateOutletContext]="{ errorMessage: error() }"
    ></ng-container>
  </glxy-page-wrapper>

  <glxy-page-wrapper widthPreset="narrow" *ngIf="webchat$ | async as webchat">
    <div class="content">
      <inbox-webchat-form
        #webchatFormComponent
        [webchat]="webchat"
        (formChange)="updateFormData($event)"
        (customKnowledgeFormChange)="updateCustomKnowledgeFormData($event)"
        (knowledgeSourcesChange)="updateKnowledgeSources($event)"
        [disabled]="isLoading()"
      ></inbox-webchat-form>
      <div class="instructions-container">
        <inbox-web-chat-instructions [widgetId]="webchat?.widgetId || ''"></inbox-web-chat-instructions>
      </div>
    </div>

    <inbox-sticky-footer
      (submitClick)="updateWebchat()"
      [cancelLink]="backUrl"
      [disabled]="isLoading()"
    ></inbox-sticky-footer>
  </glxy-page-wrapper>
</glxy-page>

<ng-template #errorTemplate let-errorMessage="errorMessage">
  <glxy-alert type="error">
    <strong>{{ 'INBOX.WEBCHAT.SETTINGS.SOMETHING_WENT_WRONG' | translate }}</strong>
    <glxy-alert-extended>
      {{ errorMessage }}
    </glxy-alert-extended>
  </glxy-alert>
</ng-template>
